import { HousingStatus } from '@funnels/types';

import { SERVER_APPLICANT1, SERVER_APPLICANT2 } from '../serverData';
import { ADDRESS1, ADDRESS2 } from './addressMockData';

const APPLICANT_WITH_NO_ADDRESS = { ...SERVER_APPLICANT2, clientId: 'test-client-id' };

const ANOTHER_APPLICANT_WITH_NO_ADDRESS = { ...SERVER_APPLICANT1, clientId: 'test-client-id-1' };

const APPLICANT_WITH_LESS_THAN_THREE_YEARS_RESIDENTIAL = {
  ...SERVER_APPLICANT2,
  clientId: 'test-client-id',
  contact: {
    ...SERVER_APPLICANT2.contact,
    currentAddress: {
      housingStatus: HousingStatus.OWN_HOME_MORTGAGE,
      residentialAddress: ADDRESS1,
      startDate: `${new Date().getFullYear() - 1}-12-01`,
    },
    mailingAddress: ADDRESS1,
  },
};

const APPLICANT_WITH_SAME_MAILING_ADDRESS_AND_RESIDENTIAL_ADDRESS = {
  ...SERVER_APPLICANT2,
  clientId: 'test-client-id',
  contact: {
    ...SERVER_APPLICANT2.contact,
    currentAddress: {
      housingStatus: HousingStatus.OWN_HOME_MORTGAGE,
      residentialAddress: ADDRESS1,
      startDate: '2020-12-01',
    },
    mailingAddress: ADDRESS1,
  },
};

const APPLICANT_WITH_DIFFERENT_MAILING_ADDRESS_AND_RESIDENTIAL_ADDRESS = {
  ...SERVER_APPLICANT2,
  clientId: 'test-client-id',
  contact: {
    ...SERVER_APPLICANT2.contact,
    currentAddress: {
      housingStatus: HousingStatus.OWN_HOME_MORTGAGE,
      residentialAddress: ADDRESS1,
      startDate: '2020-12-01',
    },
    mailingAddress: ADDRESS2,
  },
};

const APPLICANT_WITH_PREVIOUS_ADDRESSES = {
  ...SERVER_APPLICANT2,
  clientId: 'test-client-id',
  contact: {
    ...SERVER_APPLICANT2.contact,
    currentAddress: {
      housingStatus: HousingStatus.OWN_HOME_MORTGAGE,
      residentialAddress: ADDRESS1,
      startDate: '2020-12-01',
    },
    previousAddresses: [
      {
        housingStatus: HousingStatus.RENTING,
        residentialAddress: ADDRESS2,
        startDate: '2019-12-01',
        endDate: '2020-12-01',
      },
    ],
  },
};

export {
  APPLICANT_WITH_NO_ADDRESS,
  APPLICANT_WITH_SAME_MAILING_ADDRESS_AND_RESIDENTIAL_ADDRESS,
  APPLICANT_WITH_PREVIOUS_ADDRESSES,
  APPLICANT_WITH_LESS_THAN_THREE_YEARS_RESIDENTIAL,
  ANOTHER_APPLICANT_WITH_NO_ADDRESS,
  APPLICANT_WITH_DIFFERENT_MAILING_ADDRESS_AND_RESIDENTIAL_ADDRESS,
};
